// src/components/PerformanceChart.js
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from "recharts";

export default function PerformanceChart({ data }) {
  if (!data || data.length === 0)
    return <div className="text-center text-muted-foreground py-8">No data available</div>;

  return (
    <div className="bg-background p-4 rounded-2xl shadow-md">
      <h3 className="text-lg font-semibold mb-2">Performance Trend</h3>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey="leads_added" stroke="#8884d8" name="Leads Added" />
          <Line type="monotone" dataKey="leads_closed" stroke="#82ca9d" name="Leads Closed" />
          <Line type="monotone" dataKey="followups_completed" stroke="#ffc658" name="Follow-ups" />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
